/**
 * Gemello di `apps/backoffice/src/components/stato.tsx`: le stesse cinque
 * parole, dette col corpo del banco.
 *
 * Al banco non c'è lo scheletro. In ufficio serve perché la tabella arriva e
 * sposta tutto quello che ha sotto; qui la schermata che aspetta è vuota, e tre
 * rettangoli grigi al posto di una riga che dice cosa si sta aspettando sono
 * meno informativi, non di più.
 *
 * `sconosciuto` resta la parola che giustifica il componente: non lo sappiamo
 * non è non c'è niente.
 */

export type QualeStato = 'caricando' | 'vuoto' | 'nonPermesso' | 'rotto' | 'sconosciuto';

export interface PropsStato {
  readonly quale: QualeStato;
  /** Cosa significa in questa schermata. Il generico non aiuta nessuno. */
  readonly dice: string;
  /** Offerto solo su `rotto`: gli altri quattro non sono guasti da ritentare. */
  readonly riprova?: () => void;
}

export function Stato({ quale, dice, riprova }: PropsStato) {
  /*
   * Lo stato è scritto nel DOM e non solo nel testo. Senza, due stati che
   * rendono lo stesso markup sono indistinguibili per chi li prova: un test che
   * cerca la frase che ha appena passato passerebbe per tutti. È lo schema che
   * `Tessera` usa con `data-tone`, in ufficio.
   */
  if (quale === 'rotto' && riprova) {
    return (
      <div className="stato" data-stato={quale}>
        <p className="stato__dice">{dice}</p>
        <button className="mod stato__riprova" onClick={riprova}>
          Riprova
        </button>
      </div>
    );
  }

  /*
   * Senza tasto non c'è niente da impilare, e il paragrafo è lo stato: è lo
   * stesso elemento che stava qui prima — un `<p>` con 24px di padding — col
   * suo margine di default, che il `<p>` nudo aveva e che un contenitore
   * attorno gli avrebbe tolto.
   */
  return (
    <p className="stato" data-stato={quale} role={quale === 'caricando' ? 'status' : undefined}>
      {dice}
    </p>
  );
}
